export default "__VITE_ASSET__DnrEYlGY__"